const EXPIRATION = {
    ONCE: 'ONCE',
    NEVER: 'NEVER',
    PRELOAD: 'PRELOAD',
};

class Cached {
    constructor({url, promise = Promise.resolve(), expiration = EXPIRATION.ONCE}) {
        this.url = url;
        this.promise = promise;
        this.expiration = expiration;
        this.consumed = false;
        this.success = true;

        this.promise.catch(() => {
            this.success = false;
        });
    }

    get data() {
        this.consumed = true;
        return this.promise;
    }

    get expired() {
        return this.expiration !== EXPIRATION.NEVER && this.consumed;
    }

    get valid() {
        return this.success && !this.expired;
    }
}

module.exports = {
    EXPIRATION,
    INVALID: {valid: false, data: null, url: null, promise: null},
    Cached,
};
